import React, { useState, useEffect } from "react";
import axios from "axios";
import { G_API } from "../../constants/globalVar";
import PageSlider from "../PageSlider";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import DummyBanner from "../DummyBanner";

const TuitionFeePage = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${G_API}sections?type=tuitionfee`)
      .then((response) => {
        const items = response.data.DATAS ?? [];
        setItems(items);
      })
      .catch((error) => console.error(error));
  }, []);

  const customBodyStyle = {
    marginTop: "0px",
    minHeight: "1000px", // Reduced from 1500px to avoid excessive whitespace
  };

  const defaultImage = G_API + "uploads/ahnyar-logo.png";

  return (
    <>
      <DummyBanner />
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner" style={{ height: "200px" }}>
          <PageSlider inputType="tuitionfee" />
        </div>
      </div>

      <section id="team" style={customBodyStyle}>
        <div className="pt-5">
          <div className="container my-3 d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold">Financial Aid</h2>
            <div>
              <a href="/admissions" className="text-secondary text-decoration-none d-flex align-items-center">
                <BsArrowLeftCircleFill className="me-2" />
                Back to Admissions
              </a>
            </div>
          </div>

          {/* Content Area - Fixed Paragraphs */}
          <div className="lh-lg text-dark">
            {(items && (items?.length > 0)) && (
              <div>
                {items.map((item => (
                  <section id="tution-fee" style={{ backgroundColor: item.bg_color || "#C8F5E1" }} className="py-5">
                    <div className="container py-5">
                      <div
                        className={`row g-5 align-items-center d-flex ${
                          item.image_side === "left"
                            ? "flex-row-reverse"
                            : "flex-row"
                        } `}
                      >
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
                          <div className="h-100">
                            <h1 className="display-6 mb-2">{item.title}</h1>
                            
                            {item.subtitle && (
                              <h4 className="mb-4 opacity-75" style={{ color: "#111110" }}>
                                {item.subtitle}
                              </h4>
                            )}
                            <div
                              className="mb-4"
                              dangerouslySetInnerHTML={{
                                __html: item.content,
                              }}
                            />
                            {(item.action_url && item.action_url !== 'null' && item.action_url !== 'undefined') && (
                              <a
                                className="btn btn-outline-primary py-2 px-4 fw-normal rounded-5 animated slideInDown"
                                href={item.action_url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {item.action_label || "Read More"}
                              </a>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
                          <div
                            className="position-relative overflow-hidden h-100 rounded-4 shadow-sm"
                            style={{ minHeight: "400px", maxHeight: "400px" }}
                          >
                            <img
                              className="position-absolute w-100 h-100"
                              src={item.admission_img?.src|| defaultImage}
                              alt={item.title}
                              style={{
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                )))}
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default TuitionFeePage;